import { create } from 'zustand';

interface UIState {
  activeFilter: 'all' | 'offers';
  setFilter: (filter: 'all' | 'offers') => void;
}

export const useUIStore = create<UIState>((set) => ({
  activeFilter: 'all',
  setFilter: (filter) => set({ activeFilter: filter }),
}));

